import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {WidgetTypeOptions} from "@models/widget";
import Search, {SearchInputType} from "@components/custom/Search";
import {WidgetLocationOptions} from "@models/widget";
import {ClientPlatformOptions} from "@models/widget";



interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
}

const SearchWidgetsComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;

  const inputs = [{
    name: "widget_type",
    label: <FormattedMessage id="app.type" defaultMessage={`Type`}/>,
    type: SearchInputType.SELECT,
    options: WidgetTypeOptions,
    size: 7
  }, {
    name: "widget_location",
    label: <FormattedMessage id="app.widget_location" defaultMessage={`Widget Location`}/>,
    type: SearchInputType.SELECT,
    options: WidgetLocationOptions,
    size: 7
  },{
    name: "client_platform",
    label: <FormattedMessage id="app.client_platform" defaultMessage={`Client Platform`}/>,
    type: SearchInputType.SELECT,
    options: ClientPlatformOptions,
    size: 7
  },
    {
    name: "iran_access",
    label: <FormattedMessage id="iran_access" defaultMessage={`Iran Access`}/>,
    type: SearchInputType.SWITCH,
    size: 3
  }];

  return <Search inputs={inputs} search={search}/>

};

export default SearchWidgetsComponent
